import Vue from "vue";
import Vuex from "vuex";
import Translation from "front-component/modules/Translation";
import User from "@/modules/User";
import PowerBi from "@/modules/PowerBi";
import Loading from "front-component/modules/Loading";
import Topic from "@/modules/Topic";
import Feature from "@/modules/Feature";
import Budget from "@/modules/budget/Budget";
import AllocationType from "@/modules/budget/AllocationType";
import BudgetAllocation from "@/modules/budget/BudgetAllocation";
import Title from "@/modules/request/Title";
import Type from "@/modules/request/Type";
import Owner from "@/modules/Owner";
import MasterOwner from "@/modules/MasterOwner";
import GroupCommitment from "@/modules/budget/GroupCommitment";
import Request from "@/modules/request/Request";
import ImpersonationUser from "./modules/ImpersonationUser";
import NotificationMessage from "@/modules/NotificationMessage";
import FormatForm from "@/modules/monocle/FormatForm";
import MonocleSupplier from "@/modules/monocle/MonocleSupplier";
import MonocleLever from "@/modules/monocle/MonocleLever";
import MonocleFormat from "@/modules/monocle/MonocleFormat";
import MonocleFormatType from "@/modules/monocle/MonocleFormatType";
import MonoclePlace from "@/modules/monocle/MonoclePlace";
import MonocleSupport from "@/modules/monocle/MonocleSupport";
import GridProfile from "@/modules/GridProfile";
import Socle from "./modules/Socle";
import RequestFilters from "@/modules/request/RequestFilters";
import SocleFilters from "@/modules/SocleFilters";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    translation: Translation,
    user: User,
    loading: Loading,
    powerBi: PowerBi,
    topic: Topic,
    budget: Budget,
    allocationType: AllocationType,
    budgetAllocation: BudgetAllocation,
    groupCommitment: GroupCommitment,
    gridProfile: GridProfile,
    title: Title,
    type: Type,
    owner: Owner,
    request: Request,
    feature: Feature,
    masterOwner: MasterOwner,
    impersonationUser: ImpersonationUser,
    notificationMessage: NotificationMessage,
    formatForm: FormatForm,
    monocleSupplier: MonocleSupplier,
    monocleLever: MonocleLever,
    monocleFormat: MonocleFormat,
    monocleFormatType: MonocleFormatType,
    monoclePlace: MonoclePlace,
    monocleSupport: MonocleSupport,
    socle: Socle,
    socleFilters: SocleFilters,
    requestFilters: RequestFilters
  },
});

export default store;
